/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  GOHMPriceProvider,
  GOHMPriceProviderInterface,
} from "../GOHMPriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_ohm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gOhm",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "IndexFunctionNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAssetAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOHMAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenIsNotAContract",
    type: "error",
  },
  {
    inputs: [],
    name: "ASSET",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OHM",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OHM_INDEX_BASE_UNITS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "gOhmPrice",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "index",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type GOHMPriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GOHMPriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GOHMPriceProvider__factory extends ContractFactory {
  constructor(...args: GOHMPriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "GOHMPriceProvider";
  }

  deploy(
    _priceProvidersRepository: string,
    _ohm: string,
    _gOhm: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GOHMPriceProvider> {
    return super.deploy(
      _priceProvidersRepository,
      _ohm,
      _gOhm,
      overrides || {}
    ) as Promise<GOHMPriceProvider>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    _ohm: string,
    _gOhm: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      _ohm,
      _gOhm,
      overrides || {}
    );
  }
  attach(address: string): GOHMPriceProvider {
    return super.attach(address) as GOHMPriceProvider;
  }
  connect(signer: Signer): GOHMPriceProvider__factory {
    return super.connect(signer) as GOHMPriceProvider__factory;
  }
  static readonly contractName: "GOHMPriceProvider";
  public readonly contractName: "GOHMPriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GOHMPriceProviderInterface {
    return new utils.Interface(_abi) as GOHMPriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GOHMPriceProvider {
    return new Contract(address, _abi, signerOrProvider) as GOHMPriceProvider;
  }
}
